<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
  <!-- START navbar header-->
  <div class="navbar-header" *ngIf="username==='system'">
    <div class="navbar-brand  d-none d-md-flex d-lg-flex d-xl-flex" href="#/">
      <div class="brand-logo">
        <a href="#/home" class="aside-logo">
          <h3 class="pd-t-10" style="margin:0px;"></h3>
        </a>
      </div>
      <a class="nav-link" trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
        <em class="fas fa-bars" style="color:red"></em>
      </a>
    </div>
  </div>
  <!-- END navbar header-->
  <!-- START Left navbar-->
  <ul class="navbar-nav mr-auto flex-row" style="margin-left: 10px;">
    <li class="nav-item">
      <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
      <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
      <a class="nav-link sidebar-toggle d-md-none" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
        <em class="fas fa-bars" style="color:red"></em>
      </a>
    </li>
    <!-- START User avatar toggle-->
    <li class="nav-item">
      <a class="nav-link" title="Trang chủ" href="/#/home">
        <i class="fa fa-home"></i>
        {{'Trang chủ' | translate}}
      </a>
    </li>
    <!--<li class="nav-item" *ngIf="khoitao===true">
    <a class="nav-link" title="Khởi tạo" href="/#/danhmuc/khoitao">
      <i class="fab fa-kickstarter"></i>
      {{'Khởi tạo' | translate}}
    </a>
  </li>-->

    <li *ngIf="hocvientiemnang===true || hocthu===true || kiemtradauvao===true" class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Tuyển sinh" dropdownToggle>
        <span class="d-flex align-items-center">
          <i class="fas fa-file-signature"></i> {{'Tuyển sinh' | translate}}
        </span>
      </a>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
        <li>
          <div class="list-group">
            <a *ngIf="hocvientiemnang===true" class="list-group-item" href="/#/daotaos/tuyensinh">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-file-signature"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Học viên tiềm năng' | translate}}</p>
                </div>
              </div>

            </a>

            <a *ngIf="hocthu===true" class="list-group-item" href="/#/daotaos/hocthu">
              <div class="media">
                <div class="align-self-start mr-2">
                  <em class="fas fa-user-graduate" style=""></em>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Học thử' | translate}}</p>
                </div>
              </div>
            </a>

            <a *ngIf="kiemtradauvao===true" class="list-group-item" href="/#/daotaos/kiemtradauvao">
              <div class="media">
                <div class="align-self-start mr-2">
                  <em class=" fas fa-clipboard-check" style=""></em>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Kiểm tra đầu vào' | translate}}</p>
                </div>
              </div>
            </a>




          </div>
        </li>
      </ul>
    </li>
    <li class="nav-item" *ngIf="hocvien===true && loaivaitro==='1'">
      <a class="nav-link" title="Hồ sơ học viên" href="/#/daotaos/hocvien">
        <em class=" mr-2 fas fa-user-friends" style=""></em>
        {{'Hồ sơ học viên' | translate}}
      </a>
    </li>
    <li class="nav-item" *ngIf="diemdanh===true && loaivaitro==='1'">
      <a class="nav-link" title="Điểm danh" href="/#/daotaos/diemdanh">
        <em class=" mr-2 fas fa-user-check" style=""></em>
        {{'Điểm danh' | translate}}
      </a>
    </li>
    <li class="nav-item" *ngIf="solienlac===true && loaivaitro==='1'">
      <a class="nav-link" title="Sổ liên lạc" href="/#/daotaos/solienlac">
        <em class=" mr-2 fas fa-book-open" style=""></em>
        {{'Sổ liên lạc' | translate}}
      </a>
    </li>
    <li class="nav-item" *ngIf="chuongtrinhhoc===true && loaivaitro==='1'">
      <a class="nav-link" title="Chương trình học" href="/#/daotaos/khoahoc">
        <em class=" mr-2 fas fa-book-open" style=""></em>
        {{'Chương trình học' | translate}}
      </a>
    </li>
    <li *ngIf="(hocvien===true || diemdanh===true || solienlac===true || chuongtrinhhoc===true) && loaivaitro!='1'" class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Học viên" dropdownToggle>
        <span class="d-flex align-items-center">
          <i class="fas fa-user-friends"></i> {{'Học viên' | translate}}
        </span>
      </a>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
        <li>
          <div class="list-group">
            <a *ngIf="hocvien===true" class="list-group-item" href="/#/daotaos/hocvien">
              <div class="media">
                <div class="align-self-start mr-2">
                  <em class=" fas fa-user-friends" style=""></em>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Hồ sơ học viên' | translate}}</p>
                </div>
              </div>

            </a>

            <a *ngIf="diemdanh===true" class="list-group-item" href="/#/daotaos/diemdanh">
              <div class="media">
                <div class="align-self-start mr-2">
                  <em class=" fas fa-user-check" style=""></em>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Điểm danh' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="chuongtrinhhoc===true" class="list-group-item" href="/#/daotaos/khoahoc">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fab fa-leanpub"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Chương trình học' | translate}}</p>
                </div>
              </div>
            </a>

            <a *ngIf="solienlac===true" class="list-group-item" href="/#/daotaos/solienlac">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-book-open me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Sổ liên lạc' | translate}}</p>
                </div>
              </div>
            </a>

            <a *ngIf="quanlyhocphi===true" class="list-group-item" href="/#/daotaos/quanlyhocphi">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-calculator me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Quản lý học phí' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="quanlyhocphi===true" class="list-group-item" href="/#/daotaos/quanlydonghoc">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-university me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Quản lý đóng học phí' | translate}}</p>
                </div>
              </div>
            </a>


          </div>
        </li>
      </ul>
    </li>


    <li *ngIf="baocao===true" class="nav-item">
      <a class="nav-link" title="Báo cáo" href="/#/daotaos/baocao">
        <em class="fa fa-chart-area fas" style=""></em>
        {{'Báo cáo' | translate}}
      </a>
    </li>
    <li *ngIf="donvitinh===true || nhacungcap===true || dmlophoc===true || dmkhoahoc===true" class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Học viên" dropdownToggle>
        <span class="d-flex align-items-center">
          <i class="fas fa-list" style="margin-right: 5px;"></i> {{'Danh mục' | translate}}
        </span>
      </a>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
        <li>
          <a *ngIf="donvitinh===true" class="list-group-item" href="/#/danhmuc/donvitinh">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-ruler me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục đơn vị tính' | translate}}</p>
              </div>
            </div>
          </a>
          <a *ngIf="nhacungcap===true" class="list-group-item" href="/#/danhmuc/nhacungcap">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-handshake me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục nhà cung cấp' | translate}}</p>
              </div>
            </div>

          </a>
          <a *ngIf="dmlophoc===true" class="list-group-item" href="/#/danhmuc/lophoc">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="far fa-building me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục lớp học' | translate}}</p>
              </div>
            </div>

          </a>

          <a *ngIf="dmkhoahoc===true" class="list-group-item" href="/#/danhmuc/phonghoc">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fab fa-buromobelexperte me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục phòng học' | translate}}</p>
              </div>
            </div>
          </a>
          <a *ngIf="dmkhoahoc===true" class="list-group-item" href="/#/daotaos/thongtinkhoahoc">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fab fa-elementor me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục khóa học' | translate}}</p>
              </div>
            </div>
          </a>
          <a *ngIf="dmkenh===true" class="list-group-item" href="/#/danhmuc/kenh">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-chalkboard-teacher me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục kênh' | translate}}</p>
              </div>
            </div>
          </a>
          <a *ngIf="dmhedaotao===true" class="list-group-item" href="/#/danhmuc/hedaotao">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-indent me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục hệ đào tạo' | translate}}</p>
              </div>
            </div>
          </a>
          <a *ngIf="dmhedaotao===true" class="list-group-item" href="/#/danhmuc/dmtrinhdo">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-sliders-h me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục trình độ' | translate}}</p>
              </div>
            </div>
          </a>
          <a *ngIf="sanpham===true" class="list-group-item" href="/#/danhmuc/sanpham">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-box me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục sản phẩm' | translate}}</p>
              </div>
            </div>

          </a>
          <a *ngIf="khohang===true" class="list-group-item" href="/#/danhmuc/khohang">
            <div class="media">
              <div class="align-self-start mr-2">
                <i class="fas fa-warehouse me-2"></i>
              </div>
              <div class="media-body clearfix">
                <p class="m0">  {{'Danh mục kho hàng' | translate}}</p>
              </div>
            </div>

          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="quanlynhansu===true || baiviet===true || quanlyhocphi===true || thuchi===true || nhapkho===true || xuatkho===true || donvitinh===true || nhacungcap===true || sanpham===true || khohang===true" class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Thông tin khác" dropdownToggle>
        <span class="d-flex align-items-center">
          <i class="fas fa-th-large mr-2"></i> {{'Khác' | translate}}
        </span>
      </a>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
        <li>
          <div class="list-group">
            <a *ngIf="quanlynhansu===true" class="list-group-item" href="/#/daotaos/giangvien">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-users me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Quản lý nhân sự' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="quanlyhocphi===true" class="list-group-item" href="/#/daotaos/quanlyhocphi">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-calculator me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Quản lý học phí' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="thuchi===true" class="list-group-item" href="/#/daotaos/phieuthuchi">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-coins me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  Quản lý thu, chi, sổ quỹ</p>
                </div>
              </div>
            </a>
            <a class="list-group-item" href="/#/daotaos/hoadon">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-coins me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  Quản lý hóa đơn</p>
                </div>
              </div>
            </a>


            <a *ngIf="nhapkho===true" class="list-group-item" href="/#/danhmuc/nhapkho">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-inbox me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Nhập kho' | translate}}</p>
                </div>
              </div>
            </a>

            <a *ngIf="xuatkho===true" class="list-group-item" href="/#/danhmuc/xuatkho">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-share-square me-2"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Xuất kho' | translate}}</p>
                </div>
              </div>
            </a>


            <a *ngIf="guithongbao===true" class="list-group-item" href="/#/daotaos/thongbaozalokhac">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-bell"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Zalo thông báo khác' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="guithongbao===true" class="list-group-item" href="/#/daotaos/thongbaozalo">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-bell"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Zalo thông báo học phí' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="guithongbao===true" class="list-group-item" href="/#/daotaos/thongbaohocphi">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-bell"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Gửi thông báo học phí' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="guithongbao===true" class="list-group-item" href="/#/daotaos/banktransaction">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-university"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Giao dịch ngân hàng' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="baiviet===true" class="list-group-item" href="/#/daotaos/baiviet">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fas fa-newspaper"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Bài viết' | translate}}</p>
                </div>
              </div>
            </a>
            <a *ngIf="baiviet===true" class="list-group-item" href="/#/quantri/nhatkytruycap">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fab fa-leanpub"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Nhật ký truy cập' | translate}}</p>
                </div>
              </div>
            </a>


          </div>
        </li>

      </ul>
    </li>






    <!-- END User avatar toggle-->

  </ul>
  <!-- END Left navbar-->
  <!-- START Right Navbar-->
  <ul class="navbar-nav flex-row">

    <li class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Đơn vị quản lý" dropdownToggle>
        <div class="d-flex flex-column">
          <span>{{ten_don_vi}}</span>
          <small class="text-muted" *ngIf="ngay_het_han" style="font-size: 0.75rem; line-height: normal;">
            <i class="far fa-calendar-alt mr-1"></i>Hạn dùng: {{ngay_het_han}}
          </small>
        </div>
      </a>

      <!-- START Dropdown menu-->
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
        <li>
          <!-- START list group-->
          <div class="list-group" style="overflow-y: auto !important;max-height: calc(100vh - 60px) !important">
            <a class="list-group-item" (click)="changedv(u)" *ngFor="let u of dschinhanhs">
              <div class="media">
                <div class="media-body clearfix">
                  <p class="m0">  {{ u.Ten}}</p>
                </div>
              </div>
            </a>

          </div>
          <!-- END list group-->
        </li>
      </ul>
      <!-- END Dropdown menu-->
    </li>

    <li class="nav-item">
      <div class="language-container">
        <div class="language-option" [ngClass]="{'language-select': ngon_ngu==1}" (click)="ChonNgonNgu(1)">
          <img src="/assets/img/Flag_of_Vietnam.svg" class="flag" alt="Vietnam Flag" (click)="ChonNgonNgu(1)">
        </div>
        <div class="language-option" [ngClass]="{'language-select': ngon_ngu==2}" (click)="ChonNgonNgu(2)">
          <img src="/assets/img/Flag_of_the_United_Kingdom.svg" class="flag" alt="UK Flag" (click)="ChonNgonNgu(2)">
        </div>
      </div>
    </li>
    <li class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Thông tin người dùng" dropdownToggle>
        <em class="fa-2x mr-2 fas fa-user-circle" style="color: #2c2e74;"></em>

      </a>
      <!--<ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">

    </ul>-->
      <!-- START Dropdown menu-->
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
        <li>
          <!-- START list group-->
          <div class="list-group">
            <a class="list-group-item" [routerLink]="['/quantri/doimatkhau']">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-exchange"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Đổi mật khẩu' | translate}}</p>
                  <p class="m0 text-muted">
                    <small>  {{'Thay đổi mật khẩu tài khoản' | translate}}</small>
                  </p>
                </div>
              </div>
            </a>

            <a class="list-group-item" (click)="logout()">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-external-link"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">  {{'Đăng xuất' | translate}}</p>
                  <p class="m0 text-muted">
                    <small>  {{'Thay tài khoản' | translate}}</small>
                  </p>
                </div>
              </div>
            </a>



          </div>
          <!-- END list group-->
        </li>
      </ul>
      <!-- END Dropdown menu-->
    </li>
   
  </ul>
 

</nav>
<!-- END Top Navbar-->
